import React, {Component} from 'react';
import classNames from 'classnames';

class AccumulatedOptimizationCategories extends Component{

  constructor(props){
    super(props)
    this.state={data:this.props.data}
  }

  render(){
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    });

    let headers= this.state.data.map( info => {
        return <th>{info.month}</th>
    });
    let landUseTd=this.state.data.map( info => {
      return <td>{info.landUse}</td>
    });
    let floorTd=this.state.data.map( info => {
      return <td>{info.floor}</td>
    });
    let constructionTd=this.state.data.map( info => {
      return <td>{info.construction}</td>
    });
    let totalTd=this.state.data.map( info => {
      return <td>{info.total}</td>
    });
    return(
      <table className={tableClass}>
        <thead>
        <tr>
          <th>Meses</th>
          {headers}
        </tr>
        </thead>
        <tbody>
        <tr>
          <th scope="row">Dif. Uso de suelo</th>
          {landUseTd}
        </tr>
        <tr>
          <th scope="row">Dif. M2 suelo</th>
          {floorTd}
        </tr>
        <tr>
          <th scope="row">Dif. M2 construcción</th>
          {constructionTd}
        </tr>
        <tr>
          <th scope="row">Total</th>
          {totalTd}
        </tr>
        </tbody>
      </table>
    );
  }

}

export default AccumulatedOptimizationCategories;



// WEBPACK FOOTER //
// ./src/components/tables/accumulatedOptimizationCategories.js